import { PiFileTextDuotone, PiCalculatorDuotone, PiGitBranchDuotone, PiEnvelopeDuotone, PiEnvelopeOpenDuotone, PiFileDuotone, PiArrowSquareOutDuotone, PiNetworkDuotone, PiClockDuotone, PiFlagDuotone, PiGitForkDuotone, PiGitMergeDuotone } from 'react-icons/pi';

export const STEP_TYPES = {
  form: { shape: 'rect', icon: 'FileText', Icon: PiFileTextDuotone, canHavePermissions: true },
  calculation: { shape: 'rect', icon: 'Calculator', Icon: PiCalculatorDuotone },
  branch: { shape: 'diamond', icon: 'GitBranch', Icon: PiGitBranchDuotone },
  notification: { shape: 'rect', icon: 'Envelope', Icon: PiEnvelopeDuotone },
  emailForm: { shape: 'rect', icon: 'EnvelopeOpen', Icon: PiEnvelopeOpenDuotone, canHavePermissions: true },
  documentGeneration: {
    shape: 'document',
    icon: 'File',
    Icon: PiFileDuotone,
    canHavePermissions: true,
  },
  externalProcess: { shape: 'rect-bars', icon: 'ArrowSquareOut', Icon: PiArrowSquareOutDuotone, canHavePermissions: true },
  subWorkflow: { shape: 'rect-bars', icon: 'Network', Icon: PiNetworkDuotone, canHavePermissions: true },
  wait: { shape: 'rect-bars', icon: 'Clock', Icon: PiClockDuotone, canHavePermissions: true },
  end: {
    shape: 'oval',
    icon: 'Flag',
    Icon: PiFlagDuotone,
    canHavePermissions: true,
  },
  fork: { shape: 'fork', icon: 'GitFork', Icon: PiGitForkDuotone, canHavePermissions: false },
  join: { shape: 'join', icon: 'GitMerge', Icon: PiGitMergeDuotone, canHavePermissions: false },
};

// Narrowest a step card renders (end steps are pills). Widths saved by the older,
// narrower cards are raised to these on the canvas and in auto-layout.
export const CARD_MIN_WIDTH = 210;
export const PILL_MIN_WIDTH = 180;

export const UNKNOWN_STEP_TYPE = { shape: 'rect', color: '#989a9c', Icon: PiFileDuotone };

export default function getStepType(type) {
  return STEP_TYPES[type] ?? UNKNOWN_STEP_TYPE;
}
